module.exports = __webpack_public_path__ + "static/media/intro2.5b8f07c1.gif";